/** Hostname helpers for the SaaS platform vs merchant custom domains. */

export function apexHost(host) {
  const h = (host || "").toLowerCase();
  return h.startsWith("www.") ? h.slice(4) : h;
}

/**
 * True when `host` is the SaaS platform (not a merchant custom domain).
 * `backendHost` is the hostname of REACT_APP_BACKEND_URL.
 */
export function isPlatformHostname(host, backendHost) {
  const h = (host || "").toLowerCase();
  if (!h) return false;
  if (h === "localhost" || h === "127.0.0.1") return true;
  if (h.endsWith(".preview.emergentagent.com")) return true;
  if (!backendHost) return false;
  return apexHost(h) === apexHost(backendHost);
}
